import Cookies from 'js-cookie';
import { isMl3App, isAndroid, isiOS } from './DeviceOptions';
import { sleep } from './Utils';

const set = async (name, value, options) => {
  Cookies.set(name, value, options);
  if (isMl3App) {
    if (isAndroid) {
      if (window.maplife) {
        window.maplife.setCookie(name, value);
      }
    } else if (isiOS) {
      while (!document.body) {
        await sleep();
      }
      window.webkit.messageHandlers.func.postMessage('setCookie(' + name +',' + value + ')');
    }
  }
};

export default {
  ...Cookies,
  set,
  originalSet: Cookies.set,
};
